import { logic as searchLogic } from './search/searchLogic';
import { logic as propertyLogic } from './property/propertyLogic';
import { logic as userLogic } from './user/userLogic';
import { logic as fetchSiteMessageLogic } from './siteMessage/fetchSiteMessageLogic';
import { logic as fetchCampaignLogic } from './campaign/fetchCampaignLogic';
import { logic as propertyAvailabilityLogic } from './propertyAvailability/propertyAvailabilityLogic';
import { logic as quoteLogic } from './quote/quoteLogic';
import { logic as userEnvironmentLogic } from './userEnvironment/userEnvironmentLogic';
import { logic as bookingLogic } from './booking/bookingLogic';
import { logic as routerLogic } from './router/routerLogic';
import { logic as enquiryLogic } from './enquiry/enquiryLogic';
import { logic as checkoutLogic } from './checkout/checkoutLogic';
import { logic as memberFavouriteLogic } from './memberFavourites/memberFavouritesLogic';
import { logic as uiLogic } from './ui/uiLogic';
import { logic as promoAreaLogic } from './promoArea/promoAreaLogic';
import { logic as recommendedPropertyLogic } from './recommendedProperty/recommendedPropertyLogic';
import { logic as personalisationLogic } from './personalisation/personalisationLogic';
import { logic as contentLogic } from './content/contentLogic';
import { logic as faqsLogic } from './faqs/faqLogic';
import { logic as fetchPropertyExclusiveOffersPageLogic } from './propertyExclusiveOffersPage/propertyExclusiveOffersPageLogic';
import { logic as exclusiveOfferLogic } from './exclusiveOffer/exclusiveOfferLogic';
import { logic as termsAndConditionsLogic } from './termsAndConditions/termsAndConditionsLogic';
import { logic as hotelsAndAirbnbTermsAndConditionsLogic } from './hotelsAndAirbnbTermsAndConditions/hotelsAndAirbnbTermsAndConditionsLogic';
import { logic as dealLogic } from './deal/dealLogic';
import { logic as calendarLogic } from './calendar/fetchCalendarLogic';
import { logic as pointsBurnTiersLogic } from './pointsBurnTiers/pointsBurnTiersLogic';
import { logic as pointsBurnLuxeLogic } from './pointsBurnLuxe/pointsBurnLuxeLogic';
import { logic as quoteDepositPayLogic } from './quoteDepositPay/quoteDepositPayLogic/';
import { logic as activitiesStaticImageLogic } from './activitiesStaticImage/activitiesStaticImageLogic';
import { logic as iSeatzLogic } from './iSeatz/iSeatzSmartfillLogic';

export default [
  ...searchLogic,
  ...propertyLogic,
  ...userLogic,
  ...fetchSiteMessageLogic,
  ...fetchCampaignLogic,
  ...propertyAvailabilityLogic,
  ...quoteLogic,
  ...userEnvironmentLogic,
  ...bookingLogic,
  ...routerLogic,
  ...enquiryLogic,
  ...checkoutLogic,
  ...memberFavouriteLogic,
  ...uiLogic,
  ...promoAreaLogic,
  ...recommendedPropertyLogic,
  ...personalisationLogic,
  ...contentLogic,
  ...faqsLogic,
  ...fetchPropertyExclusiveOffersPageLogic,
  ...exclusiveOfferLogic,
  ...termsAndConditionsLogic,
  ...hotelsAndAirbnbTermsAndConditionsLogic,
  ...dealLogic,
  ...calendarLogic,
  ...pointsBurnTiersLogic,
  ...pointsBurnLuxeLogic,
  ...quoteDepositPayLogic,
  ...activitiesStaticImageLogic,
  ...iSeatzLogic,
];
